import { Translate } from 'next-translate';

export const prettyBusinessRegionsMap = (t: Translate) => ({
  apac: t('business_regions.apac'),
  emea: t('business_regions.emea'),
  latam: t('business_regions.latam'),
  na: t('business_regions.na'),
  undefined: ''
});

export const prettyBusinessRegion = (t: Translate, region: 'apac' | 'emea' | 'latam' | 'na' | undefined) => (
  prettyBusinessRegionsMap(t)[`${region}`]
);
